<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-badges-data-provider
            v-slot="memberScope"
            :member-id="memberId"
        >
            <div class="animated fadeIn">
                <kgr-membership-badge
                    :member-id="memberId"
                    :has-counter="hasMembershipCounter(memberScope.data)"
                />
            </div>
        </kgr-member-badges-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import KgrMembershipBadge from '../../components/members/MembershipBadge.vue';
import MemberBadgesDataProvider from '../../components/data-provider/MemberBadgesDataProvider.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-member-badges-data-provider': MemberBadgesDataProvider,
        'kgr-membership-badge': KgrMembershipBadge,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        hasMembershipCounter(badges) {
            return badges.filter((badge) => badge.hasOwnProperty('membership') && badge.membership !== null).length > 0;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
